import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ReviewMessage = ({ rating }: { rating: number }) => {
  switch (rating) {
    case 1:
      return (
        <FormattedMessage
          defaultMessage="Oh no! What was the issue?"
          id="ghLjWr"
        />
      )
    case 2:
      return (
        <FormattedMessage
          defaultMessage="Below average. What was the issue?"
          id="9MrLOH"
        />
      )
    case 3:
      return (
        <FormattedMessage
          defaultMessage="Just average. What was the issue?"
          id="pUm2M/"
        />
      )
    case 4:
      return (
        <FormattedMessage
          defaultMessage="Great! Anything we can improve?"
          id="noTybX"
        />
      )
    case 5:
      return (
        <FormattedMessage
          defaultMessage="Excellent! Tell us what you liked?"
          id="bYZbRT"
        />
      )
    default:
      return null
  }
}
